/* eslint-disable prettier/prettier */
import { TextsDeprecated } from '../../../pure-js/libs/TextsDeprecated'
import Notificaiton, { NotificationProps } from './Notification'
import { _ErrorNotification } from './NotificationError'

export const ErrorNotificaiton = _ErrorNotification
export const SuccessNotification = (props: Partial<NotificationProps>) => <Notificaiton {...props}/>
